<template>
    <b-row>
        <b-col cols="12" :lg="showHistoryVisual ? 6 : 12">
            <table class="table table-striped base-ticket-info">
            <tbody>
                <tr>
                    <td>{{ 'barcode' | lang }}</td>
                    <td>{{ ticket.barcode }}</td>
                </tr>
                <tr>
                    <td>{{ 'payout_date' | lang }}</td>
                    <td v-if="ticket.datetime_payout">{{ ticket.datetime_payout }}</td>
                    <td v-else>-</td>
                </tr>
                <tr>
                    <td>{{ 'amount' | lang }}</td>
                    <td>{{ ticket.amount | currency }}</td>
                </tr>
                <tr>
                    <td>{{ 'amount_won' | lang }}</td>
                    <td :class = "[{'text-success': ticket.datetime_payout && ticket.ticket_is_lucky}]" v-if="ticket.datetime_payout && ticket.amount_payout">{{ ticket.amount_payout | currency }}</td>
                    <td v-else>-</td>
                </tr>
                <tr>
                    <td>{{ 'payed_out' | lang }}</td>
                    <td v-if="ticket.amount_payout">{{ 'payed_out_1' | lang }}</td>
                    <td v-else>{{ 'payed_out_0' | lang }}</td>
                </tr>
            </tbody>
        </table>
        </b-col>
        <b-col cols="12" lg="6">
		    <component v-if="showHistoryVisual" v-bind:is="this.firstUpperCaseGameName" :ticket="ticket"></component>
        </b-col>
    </b-row>
</template>

<script>
    import Cleopatra from './ticket/Cleopatra';
    import Winter_night from './ticket/Winter_night';
    import El_porko_mafioso from './ticket/El_porko_mafioso';
    import The_shield_of_zeus from './ticket/The_shield_of_zeus';
    import Forest from './ticket/Forest';
    import Midsummer from './ticket/Midsummer';
    import Summer_lotto from './ticket/Summer_lotto';
    import Wheel_of_magic from './ticket/Wheel_of_magic';
    import Spooky_witchcraft from './ticket/Spooky_witchcraft';
    import Lucky_santa from './ticket/Lucky_santa';
    import Fortuna_liga from './ticket/Fortuna_liga';
    import Fortuna_casino from './ticket/Fortuna_casino';

    export default {
        data() {
            return {
                showHistoryVisual: Config.showHistoryVisual
            }
        },
        props: ['ticket', 'gameName'],
        components: {Cleopatra, Winter_night, El_porko_mafioso, The_shield_of_zeus, Forest, Midsummer, Wheel_of_magic, Spooky_witchcraft, Lucky_santa, Fortuna_liga,
            Fortuna_casino, Summer_lotto},
        computed: {
            firstUpperCaseGameName() {
                return this.gameName.charAt(0).toUpperCase() + this.gameName.slice(1);
            }
        }
    }
</script>
